export const taskLinkTypesNames = {
	finishToStart: 'FINISH_TO_START',
	finishToFinish: 'FINISH_TO_FINISH',
	startToStart: 'START_TO_START',
	startToFinish: 'START_TO_FINISH',
};

export const taskLinkTypesTitles = {
	finishToStart: 'Finish To Start (FS)',
	finishToStartInward: 'Cannot start until linked tasks finish (FS)',
	finishToFinish: 'Finish To Finish (FF)',
	finishToFinishInward: 'Cannot finish until linked tasks finish (FF)',
	startToStart: 'Start To Start (SS)',
	startToStartInward: 'Cannot start until linked tasks start (SS)',
	startToFinish: 'Start To Finish (SF)',
	startToFinishInward: 'Cannot finish until linked tasks start (SF)',
};

export const finishToStartDefinitionText = 'means the linked tasks cannot start until this task is finished';
export const finishToFinishDefinitionText = 'means the linked tasks cannot finish until this task is finished.';
export const startToStartDefinitionText = 'means the linked tasks can only start after this task starts.';
export const startToFinishDefinitionText = 'means the linked tasks cannot finish until this task starts.';
